import { Attributes, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';

export default class NoticePeriod extends TemporalEntity {

    constructor() {
        super();
        this.makeObservable();
    }

    public noticePeriodId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    public noticePeriodName: string = "";

    @Attributes.Integer()
    public months: number = 0;

    @Attributes.Integer()
    public days: number = 0;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.months < 0 ,"Months cannot be negative.");
        rules.failWhen(c => c.days < 0 ,"Days cannot be negative.");
    }

    public toString(): string {
        if (this.isNew || !this.noticePeriodName) {
            return "New notice period";
        } else {
            return this.noticePeriodName;
        }
    }
}